import React from "react";

const LiveChatHero = () => {
  return (
    <section className="relative w-full h-[70vh] md:h-[85vh] overflow-hidden">
      
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1551434678-e076c223a692?q=80&w=2070&auto=format&fit=crop"
          alt="Live Chat Support Team"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60"></div>

      {/* Gradient Right Blur Effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center h-full px-6 text-center">
        <div className="max-w-3xl text-white">
          
          <h2 className="text-2xl md:text-3xl font-light tracking-wide">
            Welcome to
          </h2>

          <h1 className="text-4xl md:text-6xl font-bold mt-2 text-yellow-300">
            Live Chat Support
          </h1>

          <p className="mt-6 text-base md:text-lg text-gray-200 leading-relaxed">
            Need assistance with your suraksha product? 
            We’ll get you the help you need quickly and efficiently.
          </p>

          {/* Optional Button */}
          <div className="mt-8">
            <button className="px-6 py-3 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold rounded-md transition duration-300 shadow-lg">
              Start Chat Now
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default LiveChatHero;